import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import { bucketTopN } from "./_shared/bucketTopN";
import { isValidShape } from "./_shared/isValidShape";
import { barOptions } from "./_shared/chartTheme";
import ChartState from "./_shared/ChartState";

const DiamondReportsShapeComp = ({ data, loading, onSliceClick, onHideNoiseChange }) => {
  const { t } = useTranslation();
  const [hideNoise, setHideNoise] = useState(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { onHideNoiseChange?.(hideNoise); }, [hideNoise]);
  const othersLabel = t("Others");
  const list = data || [];
  const chartRef = useRef();

  const filteredList = useMemo(
    () => (hideNoise ? list.filter((item) => isValidShape(item.Cut)) : list),
    [list, hideNoise]
  );
  const hiddenCount = list.length - filteredList.length;

  const { chartData: bucketed, colors } = bucketTopN(filteredList, {
    labelKey: "Cut",
    valueKey: "CNT",
    chartLabel: "Shape",
    max: 10,
    othersLabel,
  });
  const rows = bucketed.slice(1);

  const handleClick = (event) => {
    if (!onSliceClick || !chartRef.current) return;
    const [el] = getElementAtEvent(chartRef.current, event);
    if (!el) return;
    const rawLabel = rows[el.index]?.[0];
    if (rawLabel && !rawLabel.startsWith(`${othersLabel} (`)) {
      onSliceClick(rawLabel.replace(/\s*\([^)]*\)\s*$/, ""));
    }
  };

  const chartJsData = {
    labels: rows.map((row) => row[0]),
    datasets: [
      {
        label: t("Count"),
        data: rows.map((row) => row[1]),
        backgroundColor: rows.map((row, i) =>
          row[0].startsWith(`${othersLabel} (`) ? "#CCCCCC" : colors[i]
        ),
        borderRadius: 4,
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <div className="edr-panel-head">
          <label>
            <b> {t("Diamond Shape Searches")} </b>
          </label>
          <div className="edr-toggle">
            <span>{t("Hide noise / invalid terms")}</span>
            <label className="edr-switch">
              <input
                type="checkbox"
                checked={hideNoise}
                onChange={(e) => setHideNoise(e.target.checked)}
              />
              <span className="edr-switch-track"></span>
            </label>
            {hiddenCount > 0 && (
              <span className="edr-badge edr-flag">
                {hiddenCount} {t("junk terms hidden")}
              </span>
            )}
          </div>
        </div>
        <div className="chart__section">
          {!loading && rows.length > 0 ? (
            <div className="edr-chartwrap edr-tall">
              <Bar ref={chartRef} data={chartJsData} options={barOptions(true)} onClick={handleClick} />
            </div>
          ) : (
            <ChartState loading={loading} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsShapeComp;
